@for (object of objectList; track object) {
  <div class="role" [class.role--link]="!!itemAction" (click)="onClick(object)">
    <fa-icon [icon]="icon"></fa-icon>
    <a>{{ label(object) }}</a>
  </div>
}
